import React, { ReactElement } from 'react'
import styles from './Grid.module.css'

export interface GridProps {
    minRow: number
    maxRow: number
    minCol: number
    maxCol: number
    renderCell: (row: number, col: number) => ReactElement|undefined
}

export default function Grid(props: GridProps) {
    const numCols = props.maxCol - props.minCol + 1
    let rows: ReactElement[] = []
    for (let r = props.minRow; r <= props.maxRow; r++) {
        let cells: ReactElement[] = []
        for (let c = props.minCol; c <= props.maxCol; c++) {
            cells.push(
                <td key={c}>
                    {props.renderCell && props.renderCell(r, c)}
                </td>
            )
        }
        rows.push(
            <tr key={r}>
                {cells}
            </tr>
        )
    }
    return (
        <table className={styles.grid} style={{
            // we need to give the table a fixed width
            width: `calc(var(--tile-size) * ${numCols})`,
        }}>
            <tbody>
                {rows}
            </tbody>
        </table>
    )
}